import { render, staticRenderFns } from "./TableHead.vue?vue&type=template&id=fb22a940&scoped=true&"
import script from "./TableHead.vue?vue&type=script&lang=js&"
export * from "./TableHead.vue?vue&type=script&lang=js&"
import style0 from "./TableHead.vue?vue&type=style&index=0&id=fb22a940&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb22a940",
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Resize from 'vuetify/lib/directives/resize'
installDirectives(component, {Resize})
